"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringStartsFromProtocol = exports.getPosition = void 0;
const getPosition = element => {
  const {
    left,
    bottom
  } = element.getBoundingClientRect();
  return {
    left,
    bottom
  };
};
exports.getPosition = getPosition;
const stringStartsFromProtocol = str => /^(https?:\/\/)/.test(str);
exports.stringStartsFromProtocol = stringStartsFromProtocol;